import axios from 'axios';
import { store } from '../redux-stores/store';
import { setError } from '../redux-stores/slices/errorSlice';
import { logout } from '../redux-stores/slices/authSlice';
import { API_BASE_URL } from '../constants/constants';
// Create a single instance of Axios

const axiosClient = axios.create({
  baseURL: API_BASE_URL, 
  headers: {
    'Content-Type': 'application/json',
    'X-Client': 'web',
  },
});

// Request Interceptor
axiosClient.interceptors.request.use(
  (config) => {
    const token = store.getState().auth.token;
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    const appVersion = localStorage.getItem('app_version');
    if(appVersion){
      config.headers['AppVersion'] = appVersion;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor
axiosClient.interceptors.response.use(
  (response) => {
    // You can handle successful responses here if needed
    return response;
  },
  (error) => {
    if (error.response) {
        const { status } = error.response;

        // Check for 401 and redirect to login page
        if(status === 401){
          store.dispatch(logout());
        }

    // Check for 403 or 500 errors and dispatch error actions
      const errorMessage =
        status === 403
          ? 'Forbidden access. You do not have permission to view this resource.'
          : status === 500
          ? 'Internal Server Error. Please try again later.'
          : error.response.data.message || error.message;

      // Dispatching error to Redux store (assuming error slice has a setError action)
      store.dispatch(setError({ message: errorMessage, statusCode: status }));
    }

    return Promise.reject(error);
  }
);

export default axiosClient;